import React from 'react';
import { TrustBanner } from './components/TrustBanner';
import { Header } from './components/Header';
import { B2BHero } from './components/B2BHero';
import { A250FeaturedCollection } from './components/A250FeaturedCollection';
import { PartnerLogos } from './components/PartnerLogos';
import { ProductShowcase } from './components/ProductShowcase';
import { WhyPartner } from './components/WhyPartner';
import { CaseStudies } from './components/CaseStudies';
import { QuoteCalculator } from './components/QuoteCalculator';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans bg-white" data-id="element-0">
      <TrustBanner data-id="element-1" />
      <Header data-id="element-2" />
      <main className="flex-grow" data-id="element-3">
        <B2BHero data-id="element-4" />
        <A250FeaturedCollection data-id="element-5" />
        <PartnerLogos data-id="element-6" />
        <ProductShowcase data-id="element-7" />
        <WhyPartner data-id="element-8" />
        <CaseStudies data-id="element-9" />
        <QuoteCalculator data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}